import { render, staticRenderFns } from "./vNutritionLabelUS.vue?vue&type=template&id=00f88c63&scoped=true"
import script from "./vNutritionLabelUS.vue?vue&type=script&lang=ts"
export * from "./vNutritionLabelUS.vue?vue&type=script&lang=ts"
import style0 from "./vNutritionLabelUS.vue?vue&type=style&index=0&id=00f88c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f88c63",
  null
  
)

export default component.exports